import React, { ReactNode } from "react";
import { Box, Container } from "@mui/material";
import backgroundImage from "url:src/assets/images/background.png";
import backgroundInvestmentResultImage from "url:src/assets/images/background_investment_result.png";
import backgroundResidenceResultImage from "url:src/assets/images/background_residence_result.png";

type Props = {
  children?: ReactNode;
  backgroundType?: "investment_result" | "residence_result";
};

export default function ResultHeader({ children, backgroundType }: Props) {
  // 背景画像の設定
  let bgImage = backgroundImage;
  if (backgroundType === "investment_result") {
    bgImage = backgroundInvestmentResultImage;
  } else if (backgroundType === "residence_result") {
    bgImage = backgroundResidenceResultImage;
  }

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
      }}
    >
      <Box
        component="img"
        src={bgImage}
        sx={{
          width: "100%",
          height: "auto",
          display: "block",
        }}
      />

      <Box
        sx={{
          position: "absolute",
          top: "55%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "fit-content",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Container maxWidth="sm">{children}</Container>
      </Box>
    </Box>
  );
}
